<template>      
    <div id="ubn" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('death.Death_from_UBN') }}</h5>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-8">
            <div class="input-group input-group-static null">
                <label>{{ $t('death.Death_from_UBN') }}</label>
                <input v-model="state.departureFromLocation" type="text" class="form-control form-control-default" disabled>
            </div>
          </div>
        </div>        
      </div>
    </div>    
    <div id="animal" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('death.Animal') }}</h5>        
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <p class="fw-bold text-sm">{{ $t('death.Selected_animals') }}</p>
              <div class="row">
                <div v-for="animal in state.death.animals" :key="animal.id" class="col-md-6 mb-1">
                  <div class="card border  text-sm border-success bg-light">
                    <span v-html="displayText(animal)"></span>                    
                  </div>
                </div>                
              </div>
            </div>
          </div>          
        </div>        
      </div>
    </div>
    <div id="date" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('death.Date_of_death') }}</h5>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('death.Date_of_death') }}</label>
                <input v-model="state.occurrenceDate" type="text" class="form-control form-control-default" disabled>       
            </div>
          </div>          
        </div>         
      </div>    
    </div>
    <div id="destructor" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('death.Destructor_UBN') }}</h5>        
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-8">
              <div class="input-group input-group-static null">
                <label>{{ $t('death.Destructor_UBN') }}</label>
                <input v-model="state.departureToLocation" type="text" class="form-control form-control-default" disabled>
              </div>              
          </div>          
        </div>        
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { reactive } from 'vue'  
  
  export default {
    name: "DeathOverviewItem",
    setup() {

      const state = reactive ({        
        gets: [],
        death: [],
        id: '',
        occurrenceDate: null,
        departureFromLocation: '',
        departureToLocation: '',
        departureToUBN: ''
    })
    
    const displayText = (f) => {
      let parts = [];

      if (f.studbookNumber) parts.push(f.studbookNumber);
      if (f.animalNumber) parts.push(f.animalNumber);
      if (f.name) parts.push(`(${f.name})`);
      if (f.arrivalDate) {
        parts.push(`<span style="color: green">${f.arrivalDate}</span>`);
      }

      return parts.join(' | ');
    }
   
    return {
        state,
        displayText
      }
  },    
  components: {          
  },  
  async mounted() {  
      this.id = this.$route.params.id;
      
      try {
            this.$store.commit('setShowLoading', true);
            await this.fetchDeathData(this.id);            
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
    },    
    methods: {      
      async fetchDeathData(groupGuid) {

            const response = await axios.get(`death/groupoverview/${groupGuid}`);
            this.gets = response.data;
            
            if (this.gets.success) {
                this.state.death = this.gets.data;
                this.state.occurrenceDate = this.state.death.occurrenceDate;
                this.state.departureFromLocation = this.state.death.departureFromLocation;
                this.state.departureToLocation = this.state.death.departureToLocation;
            } else {
              this.$showError('errors.Contact_system_admin');
            }       
      },
    }
  };
  </script>
  <style scoped>
  .card {
    transition: background-color 0.2s ease-in-out;    
    position: relative;
    padding: 10px !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .bg-light {
    background-color: #f9f9f9 !important;
  }
  .border-success {
    border-color: #28a745 !important;
  }
</style>